// https://vuex.vuejs.org/en/actions.html

export default {
    // addTicketToCart({state, commit, getters}, options) {
    addTicketToCart({ commit }, ticket) {
        commit('pushTicketToCart', ticket);
    },
    removeTicketFromCart({ commit }, idTicket) {
        commit('spliceTicketFromCart', {id: idTicket})
    },
}
